<template>
  <div class="py-4 fade-in">
    <v-row
      no-gutters
      class="align-center white"
      style="position: sticky; top: 48px; z-index: 1"
    >
      System Logs
      <v-spacer></v-spacer>

      <!-- Logs Tools, Filter -->
      <v-btn-toggle
        v-model="type"
        @change="getLogs(true)"
        color="primary"
        class="mr-1"
        dense
        tile
      >
        <v-btn :value="'user'" x-small icon :ripple="false">U</v-btn>
        <v-btn :value="'store'" x-small icon :ripple="false">S</v-btn>
        <v-btn :value="'admin'" x-small icon :ripple="false">A</v-btn>
        <v-btn :value="'botView'" x-small icon :ripple="false">B</v-btn>
      </v-btn-toggle>
      <v-btn
        small
        icon
        @click="isGrouping = !isGrouping"
        class="mr-1"
        :class="isGrouping && 'grey white--text'"
        :ripple="false"
      >
        <v-icon small>mdi-format-list-group</v-icon>
      </v-btn>
      <v-btn
        small
        text
        class="hidden-xs-only"
        @click="showLogInfo = {}"
        :disabled="!Object.keys(showLogInfo).length"
        :ripple="false"
      >
        <v-icon left small>mdi-unfold-less-horizontal</v-icon> Hide Info
      </v-btn>
      <v-btn
        small
        text
        :icon="$vuetify.breakpoint.xs"
        @click="getLogs(true)"
        :loading="isLoading"
        :ripple="false"
      >
        <v-icon :left="$vuetify.breakpoint.smAndUp" small>mdi-refresh</v-icon>
        <span class="hidden-xs-only">Reload</span>
      </v-btn>
      <v-btn icon small @click="docFinder.show = !docFinder.show">
        <v-icon small>mdi-magnify</v-icon>
      </v-btn>
    </v-row>

    <v-divider class="my-2"></v-divider>

    <!-- Table Column Header -->
    <div
      class="
        pa-1
        text-caption
        d-flex
        flex-wrap
        align-center
        fixed-row
        grey--text
      "
      style="position: relative"
    >
      <div class="text-center">DATE TIME</div>
      <div class="text-center">INFO</div>
      <div class="text-center hidden-xs-only">TYPE</div>
      <div class="text-center">ACTION</div>
      <div class="text-center">TARGET</div>

      <!-- Docs Finder -->
      <v-card
        v-if="docFinder.show"
        outlined
        tile
        style="
          position: fixed;
          right: 8px;
          top: 112px;
          min-width: 320px;
          width: 40%;
          max-width: 600px;
          z-index: 2;
          max-height: 60%;
          overflow: auto;
        "
        elevation="2"
      >
        <div
          class="pa-1 primary lighten-1 white--text d-flex align-center"
          style="position: sticky; top: 0"
        >
          <v-select
            :items="[
              'users',
              'products',
              'stores',
              'addresses',
              'reports',
              'producttypes',
              'logs',
            ]"
            label="col"
            v-model="docFinder.col"
            hide-details
            solo
            dense
            style="width: 108px"
            append-icon=""
          ></v-select>
          <span class="mx-1">/</span>
          <v-text-field
            @keydown.enter="searchDoc()"
            v-model="docFinder._id"
            label="id (enter)"
            hide-details
            solo
            flat
            dense
          ></v-text-field>
          <v-btn
            icon
            color="white"
            class="ml-1"
            @click="docFinder.show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <pre style="white-space: pre-wrap" class="pa-1">{{
          docFinder.result
        }}</pre>
      </v-card>
    </div>

    <!-- Logs Table -->
    <v-card
      v-for="(group, key) in isGrouping
        ? logSession
        : { logs: { logs, show: true } }"
      :key="key"
      flat
      tile
      :outlined="isGrouping"
      :class="isGrouping ? 'mb-3' : ''"
    >
      <!-- Group Header -->
      <v-card
        v-if="isGrouping"
        class="pl-1 text-caption white--text d-flex"
        :class="group.user && key != 'null' ? 'primary' : 'grey'"
        @click="group.show = !group.show"
        tile
        flat
      >
        <span class="hidden-xs-only mr-2">Session {{ key }}</span>
        <template v-if="group.user && key != 'null'">
          User {{ group.user }}
        </template>
        <span class="ml-auto px-2">[ {{ group.logs.length }} ]</span>
      </v-card>

      <!-- Group's logs -->
      <template v-if="group.show">
        <div
          class="pa-1 d-flex flex-wrap align-center fixed-row"
          v-for="{
            _id,
            type,
            action,
            target,
            success,
            message,
            createdAt,
            ...ret
          } in group.logs"
          :key="_id"
          :class="
            (!success ? 'error--text ' : '') +
            ($vuetify.breakpoint.xsOnly ? 'text-caption' : 'text-subtitle-2')
          "
        >
          <div class="text-no-wrap">
            {{ new Date(createdAt).toLocaleString($langs.lang) }}
          </div>
          <div class="text-center">
            <v-btn
              x-small
              :text="!showLogInfo[_id]"
              @click="toggleInfo(_id)"
              :ripple="false"
              >{{ !showLogInfo[_id] ? "Show" : "Hide" }}</v-btn
            >
          </div>
          <div class="text-center text-truncate hidden-xs-only">{{ type }}</div>
          <div class="text-center text-truncate">{{ action }}</div>
          <div class="text-center text-truncate">{{ target }}</div>
          <v-row
            v-if="showLogInfo[_id]"
            no-gutters
            class="pa-1 my-1 grey lighten-4"
            style="width: 100%; position: relative"
          >
            <v-col cols="12" :md="docInfo[ret.ref] && 6">
              <pre style="white-space: pre-wrap" class="">{{
                { _id, success, message, ...ret, createdAt }
              }}</pre>
            </v-col>
            <v-col cols="12" md="6" v-if="docInfo[ret.ref]">
              <v-card outlined tile>
                <div class="pa-1 primary lighten-1 white--text">
                  {{ target }} / {{ ret.ref }}
                </div>
                <pre style="white-space: pre-wrap" class="">{{
                  docInfo[ret.ref]
                }}</pre>
              </v-card>
            </v-col>
            <v-btn
              v-if="ret.ref && !docInfo[ret.ref]"
              absolute
              top
              right
              x-small
              @click="loadTargetInfo(target, ret.ref)"
              :ripple="false"
              >Refer</v-btn
            >
          </v-row>
        </div>
      </template>
    </v-card>

    <v-btn
      @click="getLogs()"
      :loading="isLoading"
      :disabled="eof"
      small
      text
      :ripple="false"
      >Show more</v-btn
    >
  </div>
</template>

<script>
import admin from "../../services/admin";
export default {
  data() {
    return {
      type: null,
      isLoading: false,
      eof: false,
      isGrouping: false,

      logs: [],
      logSession: {},
      showLogInfo: {},
      docInfo: {},

      docFinder: {
        show: false,
        col: "",
        _id: "",
        result: "Enter to search",
      },
    };
  },
  mounted() {
    this.getLogs();
  },
  methods: {
    async getLogs(refresh = false) {
      const size = 100;
      let page = Math.ceil((this.logs.length || 0) / size) + 1;
      if (refresh) page = 0;

      this.isLoading = true;
      let data = await admin.getLogs({ size, page, type: this.type });
      this.isLoading = false;

      if (refresh) {
        this.logs = [];
        this.docInfo = {};
        this.logSession = {};
      }
      this.eof = !data.length;
      this.logs.push(...data);
      this.groupSession(data);
    },
    toggleInfo(id) {
      this.showLogInfo = { ...this.showLogInfo, [id]: !this.showLogInfo[id] };
    },
    async loadTargetInfo(col, _id) {
      let doc = await admin.getDocument({ col, _id });
      if (doc.success === false) return;
      this.docInfo = {
        ...this.docInfo,
        [_id]: doc._id ? doc : "Not avaiable (deleted)",
      };
    },
    async searchDoc() {
      let doc = await admin.getDocument({
        col: this.docFinder.col,
        _id: this.docFinder._id,
      });
      if (doc.success === false) return;
      this.docFinder.result = doc._id ? doc : "Not found";
    },

    groupSession(logs) {
      let logSession = { ...this.logSession };
      logs.forEach((log) => {
        let _ss = log.session || "null";
        if (logSession[_ss]) {
          logSession[_ss].logs.push(log);
        } else {
          logSession[_ss] = { logs: [log], show: !!log.session };
        }
        if (log.user && !logSession[_ss].user) {
          logSession[_ss].user = log.user;
        }
      });
      this.logSession = logSession;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/styles/styles.sass";

.fixed-row {
  & > *:first-child {
    width: 128px;
  }
  & > *:not(:first-child) {
    width: 108px;
  }
  & > *:nth-child(2) {
    width: 64px;
  }
  @media #{map-get($display-breakpoints, 'xs-only' )} {
    & > *:first-child {
      width: 116px;
    }
    & > *:not(:first-child):not(:nth-child(2)) {
      width: 64px;
    }
  }
}
</style>